import type { Middleware } from 'redux';
import type { Epic } from 'redux-observable';
import initiateStore from '@atlassian/jira-common-tangerine/src/state/initiate.tsx';
import type { Action } from './actions.tsx';
import rootReducer, { type State } from './reducer.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (
	rootEpic?: Epic<Action, State>,
	initialState?: State,

	middlewares: Middleware[] = [],
) =>
	initiateStore<State, Action, undefined>({
		appName: 'Project components',
		rootReducer,
		initialState,
		rootEpic,
		middlewares,
	});
